<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        :to="to"
        :value="value"
        :disabled="disabled"
        @click="$emit('click')"
        >
        <v-icon>mdi-{{mdi}}</v-icon>
      </v-btn>
    </template>
    <span>{{tip_}}</span>
  </v-tooltip>
</template>
<script>
export default {
  name: "VTipIconBtn",
  props: {
    to: {},
    value: {},
    tip: {},
    mdi: {
      required: true,
    },
    disabled: {},
  },
  data() {
    return {};
  },
  computed: {
    tip_() {
      return this.tip ? this.tip : this.mdi
    }
  }
};
</script>
